import LegalLayout, { H2, UL } from "@/components/layout/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout titleKey="terms" title="Terms of Service" testId="legal-terms-page">
      <H2>Acceptance of Terms</H2>
      <p>
        Welcome to AtlasForge Financial (&quot;AtlasForge,&quot; &quot;we,&quot; &quot;our,&quot; or &quot;us&quot;).
        These Terms of Service govern your access to and use of AtlasForge
        Financial websites, applications, products, services, APIs, Safe to
        Spend, Ember360, and related offerings (collectively, the &quot;Services&quot;).
      </p>
      <p>By accessing or using our Services, you agree to be bound by these Terms.</p>

      <H2>Eligibility</H2>
      <p>
        You must be at least 18 years old and legally capable of entering into
        binding agreements to use the Services.
      </p>

      <H2>Account Registration</H2>
      <p>You are responsible for:</p>
      <UL items={["Maintaining account security", "Protecting your credentials", "All activity occurring under your account"]} />
      <p>You must provide accurate and current information.</p>

      <H2>Financial Information</H2>
      <p>AtlasForge Financial is a technology company.</p>
      <p>
        Unless explicitly stated otherwise, AtlasForge is not a bank, broker-dealer,
        investment adviser, accounting firm, or tax advisor.
      </p>
      <p>
        Information provided through the Services is for informational purposes
        only and should not be considered financial, legal, investment, or tax advice.
      </p>

      <H2>Third-Party Providers</H2>
      <p>Our Services may integrate with:</p>
      <UL items={["Plaid", "Stripe", "PayPal", "Venmo", "Cash App", "Zelle", "Banking institutions", "Brokerage providers"]} />
      <p>Your use of third-party services remains subject to their respective terms and policies.</p>

      <H2>Payments</H2>
      <p>Certain Services may require subscription fees.</p>
      <p>You authorize AtlasForge to charge applicable fees for subscriptions, premium features, or paid services.</p>
      <p>Fees are generally non-refundable except where required by law.</p>

      <H2>Intellectual Property</H2>
      <p>
        All content, software, trademarks, logos, and technology associated with
        AtlasForge Financial, Safe to Spend 365, Ember360, and related Services remain
        our exclusive property.
      </p>

      <H2>Prohibited Conduct</H2>
      <p>You may not:</p>
      <UL items={["Violate laws or regulations", "Attempt unauthorized access", "Interfere with system security", "Reverse engineer our software", "Use Services for fraud or illegal activity"]} />

      <H2>Suspension and Termination</H2>
      <p>We may suspend or terminate accounts that violate these Terms or pose security, legal, or operational risks.</p>

      <H2>Disclaimer of Warranties</H2>
      <p>Services are provided &quot;AS IS&quot; and &quot;AS AVAILABLE.&quot;</p>
      <p>AtlasForge makes no warranties regarding availability, accuracy, uninterrupted access, or suitability for any particular purpose.</p>

      <H2>Limitation of Liability</H2>
      <p>
        To the maximum extent permitted by law, AtlasForge Financial shall not
        be liable for indirect, incidental, consequential, special, or punitive
        damages arising from use of the Services.
      </p>

      <H2>Indemnification</H2>
      <p>
        You agree to indemnify and hold harmless AtlasForge Financial from
        claims arising from your use of the Services or violation of these Terms.
      </p>

      <H2>Governing Law</H2>
      <p>
        These Terms shall be governed by the laws of the State of South Carolina,
        without regard to conflict of law principles.
      </p>

      <H2>Contact Information</H2>
      <p>AtlasForge Financial</p>
      <p>Email: customersupport@atlasforgefinancial.com</p>
      <p>Phone: 843-291-2556</p>

      <H2>Changes to Terms</H2>
      <p>We may update these Terms periodically. Continued use of the Services constitutes acceptance of revised Terms.</p>
    </LegalLayout>
  );
}
